import { differenceInHours } from 'date-fns';
import { Tooltip } from '@ds';
import { TrackedLocation } from '@/api/apis/resources';
import { getLastTrackedTime } from '@/utils/helpers';

type LocationCellProps = {
  locationName?: string;
  lastTrackedLocation?: TrackedLocation;
};

const getHoursFromLastLocation = (trackedTime: string) => {
  return `(${differenceInHours(new Date(), trackedTime)}h ago)`;
};

export const LocationCell = ({ locationName, lastTrackedLocation }: LocationCellProps) => {
  const lastTrackedTimeMessage = getLastTrackedTime(lastTrackedLocation);
  return (
    <div>
      <div className="text-m-r">{locationName || '-'}</div>
      {!!lastTrackedLocation && (
        <Tooltip content={lastTrackedTimeMessage} isDisabled={!lastTrackedTimeMessage} showArrow>
          <div className="text-s-r text-base-20">
            {lastTrackedLocation.address} {getHoursFromLastLocation(lastTrackedLocation.trackedTime!)}
          </div>
        </Tooltip>
      )}
    </div>
  );
};
